import type {
	NullableOption,
	IssueLinkDirection,
} from '@jira/issue-field-link-relationship-editview-full/src/types.tsx';

export const createSelectedOptionFromFieldData = (issueLinkData: {
	issueLinkTypeARI: string;
	relationName: string;
	direction: IssueLinkDirection;
}): NullableOption => {
	const { issueLinkTypeARI, relationName, direction } = issueLinkData || {};

	if (!issueLinkTypeARI || !relationName || !direction) return null;

	return {
		id: `${issueLinkTypeARI}_${direction}`,
		value: issueLinkTypeARI,
		label: relationName,
		direction,
	};
};
